import { render, staticRenderFns } from "./ClientSignatureRegister.vue?vue&type=template&id=d360b8f8"
import script from "./ClientSignatureRegister.vue?vue&type=script&lang=js"
export * from "./ClientSignatureRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports